import useABTestValue from '@hooks/useABTestValue'

export type UseShouldHideSectionSummaryBlickPlusCarousel = () => ReturnType<
  typeof useABTestValue<'hideSectionSummaryBlickPlusCarousel'>
>

const useShouldHideSectionSummaryBlickPlusCarousel: UseShouldHideSectionSummaryBlickPlusCarousel =
  () => useABTestValue('hideSectionSummaryBlickPlusCarousel')

export default useShouldHideSectionSummaryBlickPlusCarousel
